var _path, _path2, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 126,
    viewBox: "0 0 82 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5 121H34C47.2548 121 58 110.255 58 97V0",
    stroke: "#D9EDFC",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1656e-07 126C1.32608 126 2.59785 125.473 3.53553 124.536C4.47322 123.598 5 122.326 5 121C5 119.674 4.47322 118.402 3.53553 117.464C2.59785 116.527 1.32608 116 1.90735e-06 116L7.35117e-07 121L5.1656e-07 126Z",
    fill: "#D9EDFC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 65,
    rx: 21,
    ry: 21,
    transform: "rotate(-90 58 65)",
    fill: "#ACDAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.125 67.812C59.125 66.881 59.88 66.125 60.812 66.125C61.744 66.125 62.499 66.88 62.499 67.812C62.499 68.744 61.744 69.499 60.812 69.499C59.883 69.503 59.128 68.754 59.125 67.825C59.125 67.821 59.125 67.817 59.125 67.812Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M59.6199 66.62L56.3799 63.38",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M62.0098 66.62L65.2398 63.38",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.875 62.188C56.875 63.119 56.12 63.875 55.188 63.875C54.256 63.875 53.5 63.12 53.5 62.188C53.5 61.255 54.255 60.5 55.188 60.5C56.117 60.496 56.872 61.245 56.875 62.174C56.875 62.179 56.875 62.183 56.875 62.188Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M50.7598 66.62L53.9898 63.38",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.125 62.188C68.125 63.119 67.37 63.875 66.438 63.875C65.506 63.875 64.75 63.12 64.75 62.188C64.75 61.256 65.505 60.501 66.437 60.501C67.366 60.497 68.121 61.246 68.124 62.175C68.125 62.179 68.125 62.183 68.125 62.188Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.875 67.812C47.875 66.881 48.63 66.125 49.562 66.125C50.494 66.125 51.25 66.88 51.25 67.812C51.25 68.744 50.495 69.499 49.563 69.499C48.634 69.503 47.879 68.754 47.876 67.825C47.875 67.821 47.875 67.817 47.875 67.812Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 52.5,
    r: 6.5,
    fill: "#55B9FE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53.3331L75.6669 55L77.3338 53.3331",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6665 55V50",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardicon);
export default __webpack_public_path__ + "static/media/dashboardicon.eae688fd145e977a618e6bc922d0bd13.svg";
export { ForwardRef as ReactComponent };